/**
 * PageSkeleton — Fallback visivo per React.lazy() Suspense.
 * Replica la struttura del layout (sidebar + content) con shimmer animato.
 */
const shimmer = `
  @keyframes sk-shimmer {
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
  }
`;

const SkimBlock = ({ w = '100%', h = 20, r = 8, mt = 0 }) => (
    <div style={{
        width: w, height: h, borderRadius: r, marginTop: mt,
        background: 'linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%)',
        backgroundSize: '800px 100%',
        animation: 'sk-shimmer 1.6s infinite linear',
    }} />
);

export default function PageSkeleton() {
    return (
        <>
            <style>{shimmer}</style>
            <div style={{
                display: 'flex',
                minHeight: '100vh',
                background: '#030014',
            }}>
                {/* Sidebar skeleton */}
                <div style={{
                    width: 240,
                    minHeight: '100vh',
                    background: 'rgba(255,255,255,0.02)',
                    borderRight: '1px solid rgba(255,255,255,0.06)',
                    padding: '24px 16px',
                    flexShrink: 0,
                }}>
                    {/* Logo */}
                    <SkimBlock h={36} r={10} />
                    {/* Nav items */}
                    {[...Array(8)].map((_, i) => (
                        <SkimBlock key={i} h={36} r={8} mt={12} />
                    ))}
                </div>

                {/* Main content skeleton */}
                <div style={{ flex: 1, padding: '32px 40px' }}>
                    {/* Header */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <SkimBlock w={200} h={28} r={8} />
                        <SkimBlock w={120} h={36} r={8} />
                    </div>

                    {/* KPI cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginTop: 32 }}>
                        {[...Array(4)].map((_, i) => (
                            <div key={i} style={{
                                background: 'rgba(255,255,255,0.03)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                borderRadius: 12,
                                padding: 20,
                            }}>
                                <SkimBlock w="60%" h={14} r={6} />
                                <SkimBlock w="80%" h={28} r={6} mt={12} />
                            </div>
                        ))}
                    </div>

                    {/* Content block */}
                    <div style={{
                        background: 'rgba(255,255,255,0.03)',
                        border: '1px solid rgba(255,255,255,0.06)',
                        borderRadius: 12,
                        padding: 24,
                        marginTop: 24,
                    }}>
                        {[...Array(6)].map((_, i) => (
                            <SkimBlock key={i} w={`${85 - i * 5}%`} h={16} r={6} mt={i === 0 ? 0 : 14} />
                        ))}
                    </div>

                    {/* Second block */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 16,
                        marginTop: 24,
                    }}>
                        {[0, 1].map(col => (
                            <div key={col} style={{
                                background: 'rgba(255,255,255,0.03)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                borderRadius: 12,
                                padding: 24,
                            }}>
                                <SkimBlock h={18} r={6} />
                                {[...Array(4)].map((_, i) => (
                                    <SkimBlock key={i} w="90%" h={14} r={6} mt={12} />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
